/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  width: 601px;
  flex: 1;
  position: relative;
  border: 1px solid ${Palette.PrimaryGray._200};
`;

//ColumnsSection && EventsSection
export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${Palette.PrimaryGray._200};
  padding-top: 22px;
  width: 50%;
  height: 396px;
  font-size: 14px;

  &:last-child {
    border-right: unset;
  }
`;

export const SectionBox = styled.div`
  padding: 8px 8px 22px 0;
  overflow-y: auto;
  height: 100%;
  margin-right: 4px;

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

export const RowElement = styled.div`
  flex-wrap: nowrap;
  display: flex;
  align-items: center;
  height: 48px;
`;

export const ParagraphBox = styled.div`
  width: 65%;
  margin-left: 16px;
`;

export const ExportLoader = styled.div`
  width: 400px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  background-color: ${Palette.PrimaryGray._100};
  border-radius: 8px;
`;

export const LoaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  width: 100%;
`;

export const LoaderTextWrap = styled.div`
  flex-grow: 1;
`;

export const LoaderText = styled.div`
  font-size: 14px;
  line-height: 1.35;
  color: ${Palette.PrimaryGray._700};
`;

export const LoaderTextSmall = styled.div`
  font-size: 12px;
  color: ${Palette.PrimaryGray._500};
`;
